<template>
  <section class="scrollable padder">
    <div v-if="loading" class="loading">Loading&#8230;</div>
    <div v-if="showAlert" class="alert alert-danger alert-dismissible">
      <button
        type="button"
        class="close"
        aria-hidden="true"
        @click="closeAlert"
      >
        ×
      </button>
      <h4><i class="icon fa fa-ban"></i> Error!</h4>
      {{ errMessage }}
    </div>
    <section class="panel panel-default">
     
      <div class="modal-body">
        <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(addEdit)" method="post">
            
          <div class="col-sm-12">
             <ValidationProvider
               name="Vendor Type"
                  rules="required"
                  v-slot="{ errors }"
               >
            <div class="form-group">
              <label for="type">
                Vendor Type <span class="required-color">*</span></label
              >
              <input
                type="text"
                id="type_name"
                class="form-control"
                v-model="typeName"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid Vendor Type"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Vendor Type"
              />
               <span style="color:red">{{ errors[0] }}</span>
            </div>
          
                </ValidationProvider>
          </div>

          <div class="modal-footer" style="text-align: right">
           
            <button
              :disabled="saveCat"
              id="btn_save"
              type="submit"
              class="btn btn-success  text-center  "
            >
              Save
            </button>
             <a
              v-on:click="$emit('hide-form')"
              class="btn btn-danger  text-center  "
            >
              Close
            </a>
          </div>
        </form>
        </ValidationObserver>
      </div>
      
    </section>
  </section>
</template>

<script>
import api from "../api";

export default {
  props: ["typeId"],
  name: "AddVendorType",
  data() {
    return {
      saveCat: false,
      type_id: '',
      typeList: [],
      errors : [],
      typeName: "",
      loading: false,
    };
  },
  methods: {
    addEdit() {
       this.loading = false
      this.saveCat = true;
      this.type_id = this.$props.typeId;
      this.errors = []
      if (!this.typeName) {
        this.errors.push("Vendor Type required.");
      }
      if(!this.errors.length){
      const addForm = {
        "type-form": {
          type_id: this.type_id,
          type_name: this.typeName
        },
      };
      if (this.type_id > 0) {
        api
          .request("post", "GeneralApis/edit_vendor_type", addForm)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              alert("Succesfully Updated");
              this.$emit("hide-form");
              this.$emit("list-items");
            }
          });
      } else {
        api
          .request("post", "GeneralApis/add_vendor_type", addForm)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              alert("Succesfully Added");
              this.$emit("hide-form");
              this.$emit("list-items");
            }
          });
      }
      }
    },
    getList: function() {
      var id = this.$props.typeId;
      (this.typeList = []),
        (this.typeName = ""),
        (this.type_id = 0);
      if (id > 0) {
        this.type_id = id;

        const getlist = {
          filter: {
            type_id: this.type_id,
          },
        };
        api
          .request("post", "GeneralApis/get_vendor_types", getlist)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              this.typeList = data.typeList[0];
              this.typeName = this.typeList.type_name;
            }
          });
      }
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
